import script from "./speed_governor.vue?vue&type=script&setup=true&lang=js"
export * from "./speed_governor.vue?vue&type=script&setup=true&lang=js"

import "./speed_governor.vue?vue&type=style&index=0&id=161de64c&lang=css"

const __exports__ = script;

export default __exports__